import { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import CommonGrid from "../../components/CommonGrid";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { gridColumns_LoanCharges } from "../../Utils/TableColumnDefs";
import { useAbortController } from "../../hooks/useAbortController";

const LoanCharges = ({ loanId }) => {
  const [loanChargesColumnData, setLoanChargesColumnData] = useState(null);
  const { signal } = useAbortController();
  useEffect(() => {
    const getData = async () => {
      const res = await axios.get(urls.dashboard.getLoanCharges(loanId), {
        signal,
      });
      const data = res.data[0]?.map((item) => ({
        ...item,
        "Unpaid Balance": item?.["Unpaid Balance"].includes("$")
          ? item?.["Unpaid Balance"].replace("$", "")
          : item?.["Unpaid Balance"],
      }));
      setLoanChargesColumnData(data);
    };
    getData();
  }, [loanId]);

  return (
    <div className="row">
      {loanChargesColumnData ? (
        <CommonGrid
          title={"Loan Charges"}
          gridColumns={gridColumns_LoanCharges}
          columnData={loanChargesColumnData}
          tableTotal={["Unpaid Balance"]}
        />
      ) : (
        <SpinnerBlock />
      )}
    </div>
  );
};
export default LoanCharges;
